import { Navigate } from "react-router";
import { useAuth } from "../hooks/useAuth.jsx";

// eslint-disable-next-line react/prop-types
export const ProtectedRoute = ({ children }) => {
    const { user } = useAuth();
    if (!user) {
      // user is not authenticated
      return <Navigate to="/login" />;
    } 
    return children;
  };